import request from "@/utils/request";

export function getSignature(params) {
  return request({
    url: "/api/system/wx/getSignature",
    //url: "http://mall.5baiwan.top/api/system/wx/getSignature",
    method: "post",
    data: params
  });
}
export function getSignature1(params) {
  return request({
    url: "/api/system/wx/getSignature1",
    //url: "http://mall.5baiwan.top/api/system/wx/getSignature1",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/login/wx.js